import { Button } from '@shared/ui/button';
import { Tabs } from '@shared/ui/tabs';
import { Plus } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Summary } from '../summary';
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { CurrentList } from '../currentList';
import { HistoryList } from '../historyList';

interface landingProps {
  // Add your props here
}

export const TransferLandingPage: React.FC<landingProps> = () => {
  const navigate = useNavigate();
  const remoteUtilityId = useRemoteUtilityId();

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="page-title">Account Transfers</h1>
          <p className="page-subtitle">Manage account ownership transfers and name changes.</p>
        </div>
        <div className="flex gap-2">
          <Button onClick={() => {
            localStorage.removeItem(`transfer-request-progress-${remoteUtilityId}`);
            navigate("/cx/transfer/create");
          }}>
            <Plus className="mr-2 h-4 w-4" />
            Create Transfer Request
          </Button>
        </div>
      </div>

      <Summary />

      <div className="flex flex-col space-y-4">
        <div className="w-full overflow-hidden">
        <Tabs 
        defaultValue="current"
        className="w-full"
        tabsListClassName="grid w-full grid-cols-2 mb-6"
        urlMapping={{
          current: "current",
          history: "history",
        }}
        tabComponents={{
          current: {
            label: "Current",
            component: <CurrentList />
          },
          history: {
            label: "History",
            component: <HistoryList />
          }
        }}
      />
        </div>
      </div>
    </div>
  );
};

export default TransferLandingPage;
